import React from "react";

const RecentOrdersIcon = () => {
    return (
        <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="oh5qm2ggoa" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="35" height="35">
                <path fill="#D9D9D9" d="M0 0h35v35H0z"/>
            </mask>
            <g mask="url(#oh5qm2ggoa)">
                <mask id="dmyhjpjfsb" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="35" height="35">
                    <path fill="#D9D9D9" d="M0 0h35v35H0z"/>
                </mask>
                <g mask="url(#dmyhjpjfsb)" stroke="#fff" strokeWidth="2" strokeMiterlimit="10">
                    <path d="m17.927 31.698 14.075-7.226V10.698l-14.075 6.7-13.925-6.7v14l13.925 7z" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M32.002 10.699 17.927 4.3 4.002 10.699M17.927 17.398v14.3" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="m24.249 7.462-12.72 6.473" strokeLinecap="square" strokeLinejoin="bevel"/>
                    <path d="M11.528 14.312v6.021" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
            </g>
        </svg> 
    );
};

export default RecentOrdersIcon;